import { QueryDocumentSnapshot } from "firebase/firestore";
import { create } from "zustand";
import {
  countReferidos,
  fetchReferidosLoteado,
  type Referido,
} from "../firebase/firestore/referidos";
import { useDateRangeStore } from "./useDateRangeStore";

type ReferidosStore = {
  countTotal: number;
  allReferidos: Referido[];
  lastDoc?: QueryDocumentSnapshot;
  hasMore: boolean;
  fetchCounts: () => Promise<void>;
  fetchAllReferidos: () => Promise<void>;
  fetchNextPage: () => Promise<void>;
  resetReferidos: () => void;
};

export const useReferidosStore = create<ReferidosStore>((set, get) => ({
  countTotal: 0,
  allReferidos: [],
  lastDoc: undefined,
  hasMore: true,

  fetchCounts: async () => {
    const { fechaInicio, fechaFin } = useDateRangeStore.getState();
    const total = await countReferidos(fechaInicio.toDate(), fechaFin.toDate());
    set({ countTotal: total });
  },

  fetchAllReferidos: async () => {
    const { fechaInicio, fechaFin } = useDateRangeStore.getState();
    const { referidos, lastDoc } = await fetchReferidosLoteado(
      fechaInicio.toDate(),
      fechaFin.toDate(),
      undefined
    );
    set({
      allReferidos: referidos,
      lastDoc,
      hasMore: !!lastDoc,
    });
  },

  fetchNextPage: async () => {
    const { fechaInicio, fechaFin } = useDateRangeStore.getState();
    const { lastDoc: currentLastDoc, hasMore } = get();

    if (!hasMore) return;

    const { referidos, lastDoc: newLastDoc } = await fetchReferidosLoteado(
      fechaInicio.toDate(),
      fechaFin.toDate(),
      currentLastDoc
    );

    set((state) => ({
      allReferidos: [...state.allReferidos, ...referidos],
      lastDoc: newLastDoc,
      hasMore: !!newLastDoc,
    }));
  },

  resetReferidos: () => {
    set({
      allReferidos: [],
      lastDoc: undefined,
      hasMore: true,
    });
  },
}));
